import { withCompInfo } from '@wix/editor-elements-integrations'
import { MenuToggleCSS, MenuToggleDefinition } from './MenuToggle'
import { isFixedPosition, getTopCSS, getLeftCSS } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<MenuToggleCSS, MenuToggleDefinition>()(
	[
		'compLayout',
		'compSingleLayout',
		'isMobileView',
		// @ts-ignore - Remove once isOneDocMigrated is added to the compInfo
		'isOneDocMigrated',
	],
	({
		compLayout,
		compSingleLayout,
		isMobileView,
		// @ts-ignore - Remove once isOneDocMigrated is added to the compInfo
		isOneDocMigrated,
	}) => {
		const fixedPosition = isFixedPosition(compLayout, compSingleLayout)
		const top = getTopCSS(compLayout, compSingleLayout)
		const left = getLeftCSS(compLayout, compSingleLayout)
		return (!isOneDocMigrated && fixedPosition && isMobileView) ||
			(isOneDocMigrated && compSingleLayout?.itemLayout?.type === 'FixedPositionItemLayout')
			? {
					'margin-top': 'var(--wix-ads-height)',
					position: 'fixed !important',
					top,
					left,
			  }
			: {}
	}
)
